import type { FC } from 'react'

import { Th } from '@skytech/ui/Table/Th'
import type { SortingMode } from '@skytech/utils'

import { Translation } from '@/components/i18n/Translation'

import type { TradeInOrders } from '../resources'

export const OrdersTHead: FC<{
  handleSort: (id: keyof TradeInOrders, sortMode: SortingMode) => void
}> = ({ handleSort }) => (
  <thead>
    <tr>
      <Th id="productName" onClick={handleSort}>
        <Translation id="Product Name" />
      </Th>

      <Th id="assetDate" className="center hidden md:table-cell" onClick={handleSort}>
        <Translation id="Purchase date" />
      </Th>

      <Th id="grade" className="center hidden md:table-cell" onClick={handleSort}>
        <Translation id="Grade" />
      </Th>

      <Th id="estimatedPrice" className="center hidden md:table-cell" onClick={handleSort}>
        <Translation id="Estimated price" />
      </Th>

      <Th id="finalGrade" className="center hidden md:table-cell" onClick={handleSort}>
        <Translation id="Final grade" />
      </Th>

      <Th id="finalPrice" className="center hidden md:table-cell" onClick={handleSort}>
        <Translation id="Final price" />
      </Th>

      <Th className="center" id="orderStatus" onClick={handleSort}>
        <Translation id="Status" />
      </Th>
    </tr>
  </thead>
)
